import { JSEncrypt } from 'jsencrypt'

export default {
  install(Vue, options) {
    Vue.prototype.$rsaEncrypt = function(rsaPublicKey,str){
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(rsaPublicKey);
      return encrypt.encrypt(str)
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/utils/globalMethods.js